import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSquarespaceComponent } from './simple-icons-squarespace.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSquarespaceComponent ],
    exports:      [ SimpleIconsSquarespaceComponent ],
    bootstrap:    []
})
export class SimpleIconsSquarespaceModule {}
